import React from 'react'
import {useState} from 'react'
import { Stack, Typography, AntSwitch, Button, Grid,Card, Switch  } from '@mui/material';
import axios from 'axios';
import emailjs from "emailjs-com";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";


const DayCheck = (props) => {
   
    
    const checkResult = [{name: 'CAT', isOk: false}, {name: 'FC',  isOk: false}, {name: 'CG',  isOk: false},{name: 'pulse',  isOk: false},{name: 'AW',  isOk: false}, {name: 'malac',  isOk: false},{name: 'IV',  isOk: false}];
    const [loading, setLoading] = useState('שליחה');
  


   
    // const changeCheck = (e) =>{
    //     console.log(props)
     
       
    //         let found = false, index = 0;
    //         for(let i = 0; i < checkResult.length; i++){
                
    //             if(e.target.value == checkResult[i].name){
    //                 found = true;
    //                 index = i;
    //                 break;
    //             }

    //     }
        
    //     if(found){
    //         checkResult[index] = {name: e.target.value, isOk: e.target.checked}
    //     }else{
    //          checkResult.push({name: e.target.value, isOk: e.target.checked})
           
    //     }
    // if(checkResult.length == 0) checkResult.push({name: e.target.value, isOk: e.target.checked})
       
       
    // }
    

   


 
    const sendMail = async () =>{
        
     
        // let resultString = ''
        // for (let i = 0; i < checkResult.length; i++){
        //     resultString += 'name: ' + checkResult[i].name +  '\n' + ' isOk? ' + checkResult[i].isOk +'\n'
        // }
        
       
        // setLoading('שולח...')
    
    
        // emailjs
        // .send(
        //   "service_jxmmfzs", // EmailJS Service ID (from dashboard)
        //   "template_f5izike", // EmailJS Template ID
        //   {
        //     to_email: "betzalelb787@gmail.com", // Replace with the specific email
        //     from_name: "Your Name",
        //     message: "Hello, this is a test email!",
        //   },
        //   "KCTg5IeSQHKHMyJsX" // EmailJS Public Key
        // )
        // .then((response) => {
        //   console.log("Email sent!", response);
        //   alert("נשלח בהצלחה")
        // })
        // .catch((error) => {
        //   console.error("Error sending email:", error.message);
        // });
    }
  return (
    <div class="iframe" dir='rtl'>
<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdSESI85z-5AKzi79vE2Zk_VUu4-KeyiY0Xk1VAmWfA-Kkr5w/viewform?embedded=true" width="100%" height="2000px" frameborder="0" marginheight="0px" marginwidth="0">Loading…</iframe>    </div>
  /*   <Stack elevation={1} >
{       

   <Grid container spacing={0} justifyContent='center'>
                    <Typography color='primary' variant='h4'>בדיקת ווסט יומית</Typography>
//         <Grid xs={12}>
            <Card justifyContent='center' elevation={0} sx={{
                 display: "flex",
                 justifyContent: 'center'
            } }>
            
               
                <Grid id="dtbl" container xs={10} justifyContent='center' alignItems='center'>
                    <Grid xs={4} >
                        <Typography  variant='h5'>שם</Typography>

                    </Grid>
                    <Grid xs={4}>
                        <Typography variant='h5'>כמות</Typography>

                    </Grid>
                    <Grid xs={4}>
                    <Typography variant='h5'>תקינות</Typography>
                    </Grid>

                    <Grid xs={4}>
                        <Typography  variant='h6'>C.A.T</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>2</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='CAT' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>
                    <Grid xs={4}>
                        <Typography  variant='h6'>F.C</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>2</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='FC' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>

                    <Grid xs={4}>
                        <Typography  variant='h6'>C.G</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>1</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='CG' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>
                    <Grid xs={4}>
                        <Typography  variant='h6'>פאלס</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>1</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='pulse' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>
                    <Grid xs={4}>
                        <Typography  variant='h6'>A.W</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>2</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='AW' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>
                    <Grid xs={4}>
                        <Typography  variant='h6'>מלע"כ</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>1</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='malac' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>
                    <Grid xs={4}>
                        <Typography  variant='h6'>ערכה לוריד</Typography>

                    </Grid>
                    <Grid xs={2}>
                        <Typography variant='h6'>1</Typography>

                    </Grid>
                    <Grid xs={6}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography>לא תקין</Typography>
                            <Switch value='IV' onChange={changeCheck}/>
                            <Typography> תקין</Typography>
                        </Stack>
                    </Grid>

                </Grid>
                

     
            </Card>
//         </Grid>
            
   </Grid>
   
   <Button onClick={sendMail} variant='outlined' value={loading}>{loading}</Button>
   </Stack> }*/
  )
}

export default DayCheck